import React, { useContext, useMemo, useState } from 'react';
import { SetConfigDataFunction, TestConfigContextValue, TestConfigData } from './test-configurator-provider.interfaces';

const DEFAULT_CONFIG_DATA: TestConfigData = {
  isExamTemplatePreloaded: true,
};

const TestConfiguratorContext = React.createContext<TestConfigContextValue>({} as any);

export const TestConfiguratorProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [configData, setConfigData] = useState<TestConfigData>(DEFAULT_CONFIG_DATA);

  const setGivenConfigData: SetConfigDataFunction = (givenConfigData, { isOverwritten } = {}) => {
    if (isOverwritten) {
      setConfigData(givenConfigData);
    } else {
      setConfigData({ ...configData, ...givenConfigData });
    }
  };

  const value: TestConfigContextValue = useMemo(() => {
    return {
      configData,
      setConfigData: setGivenConfigData,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configData]);

  return <TestConfiguratorContext.Provider value={value}>{children}</TestConfiguratorContext.Provider>;
};

export const useTestConfiguratorContext = () => {
  const testConfiguratorContext = useContext(TestConfiguratorContext);
  if (!testConfiguratorContext) {
    console.warn('useTestConfiguratorContextValue must be used inside TestConfiguratorContext provider.');
  }
  return testConfiguratorContext;
};
